import { createSelector } from 'reselect';
const getUserInfo = (state) => state.userInfo;
const getUserData = (state) => getUserInfo(state).data;
const emptyObj = {};
export const selectUserInfo = createSelector(getUserInfo, (userInfo) => userInfo.data);
export const selectLoggingOut = createSelector(getUserInfo, (userInfo) => userInfo.loggingOut);
export const selectUserData = createSelector(getUserInfo, ({ userData }) => userData);
export const selectUserDataFetching = createSelector(getUserInfo, ({ userDataFetching }) => userDataFetching);
export const selectUserInfoFetching = createSelector(getUserInfo, (userInfo) => userInfo.fetching);
export const selectUserInfoLoaded = createSelector(getUserInfo, (userInfo) => userInfo.loaded);
export const selectUserInfoVersions = createSelector(getUserInfo, (userInfo) => userInfo.versions);
export const selectVersions = createSelector(getUserInfo, (userInfo) => userInfo.versions);
export const selectUserId = createSelector(getUserData, ({ UserId = null }) => UserId);
export const selectIsSuperRightsActive = createSelector(getUserInfo, ({ isSuperRightsActive }) => isSuperRightsActive);
export const selectIsEktacoUser = createSelector(getUserData, ({ IsEktacoUser = false }) => IsEktacoUser);
export const selectIsSuper = createSelector(selectIsEktacoUser, selectIsSuperRightsActive, (IsEktacoUser, isSuper) => IsEktacoUser && isSuper);
export const selectUserRightsObject = createSelector(getUserData, ({ UserGroupWithRights = emptyObj }) => UserGroupWithRights || emptyObj);
export const selectUserRights = createSelector(getUserData, ({ UserGroupWithRights = emptyObj }) => UserGroupWithRights.Rights || emptyObj);
export const selectUserVisibilityLevelRight = createSelector(getUserData, ({ UserGroupWithRights = emptyObj }) => {
    const trueFlag = Object.entries(UserGroupWithRights.Rights?.SelectWithValue[0]?.Flags).find(([_flag, value]) => !!value);
    return trueFlag?.[0]; // Flag Key
});
export const selectUserVisibilityRightDepartmentIds = createSelector(getUserData, ({ UserGroupWithRights = emptyObj }) => {
    const userViewLevelRights = UserGroupWithRights?.Rights?.SelectWithValue;
    return userViewLevelRights.reduce((departmentIdsAcc, right) => {
        if (right.Flags.Department && right.Value) {
            departmentIdsAcc.push(right.Value);
        }
        return departmentIdsAcc;
    }, []);
});
export const selectUserGroupWithRights = createSelector(getUserData, ({ UserGroupWithRights = emptyObj }) => UserGroupWithRights);
export const selectIsManagerMode = createSelector(getUserData, ({ UserGroupWithRights = emptyObj }) => UserGroupWithRights.ViewMode === 0);
export const selectIsWriteEnabled = createSelector(selectUserRights, (state, rightId) => ({ isSuper: selectIsSuper(state), rightId }), ({ ReadWrite }, { isSuper, rightId }) => {
    let enabled = true;
    ReadWrite.some(({ Id, Flags: { Write } }) => {
        if (Id === rightId) {
            enabled = Write;
            return true;
        }
        return false;
    });
    return enabled || isSuper;
});
export const selectIsReadEnabled = createSelector(selectUserRights, (state, rightId) => ({ isSuper: selectIsSuper(state), rightId }), ({ ReadWrite }, { isSuper, rightId }) => {
    let enabled = true;
    ReadWrite.some(({ Id, Flags: { Read } }) => {
        if (Id === rightId) {
            enabled = Read;
            return true;
        }
        return false;
    });
    return enabled || isSuper;
});
